import React, { useMemo } from 'react';
import { useEditorStore } from './editor-store';
import { ContextMenuButton } from './components/context-menu-button';
import { shallow } from 'zustand/shallow';
import { useClipboardStore } from './utils/clipboard.store';
import { getRenderShortcut } from './block-context-menu-content';
import { useCreateBlockActions } from './utils/create-block-actions.hook';
import classNames from 'classnames';
import last from 'lodash/last';

export const CanvasContextMenu = () => {
  const clearContextMenuState = useEditorStore((state) => state.clearContextMenuState);
  const undo = useEditorStore((state) => state.undo);
  const redo = useEditorStore((state) => state.redo);
  const undoable = useEditorStore((state) => state.undoStack.length > 0, shallow);
  const redoable = useEditorStore((state) => state.redoStack.length > 0, shallow);

  const lastBlockOnCurrentSection = useEditorStore(
    (state) => last(state.layout.sections.find((section) => section.id === state.currentSectionId)?.blocks || []),
    shallow
  );

  const { pasteBlock } = useCreateBlockActions();
  const enablePasteForBlock = useClipboardStore((state) => state.enablePasteForBlock, shallow);

  const onPasteBlock = () => {
    if (lastBlockOnCurrentSection) {
      pasteBlock(lastBlockOnCurrentSection.id);
    } else {
      pasteBlock();
    }

    clearContextMenuState();
  };

  const onUndoAction = () => {
    undo();
    clearContextMenuState();
  };

  const onRedoAction = () => {
    redo();
    clearContextMenuState();
  };

  const BasicContextMenuOptions = useMemo(
    () => [
      {
        label: 'Paste',
        renderShortcut: getRenderShortcut('V'),
        onClick: onPasteBlock,
        disable: !enablePasteForBlock,
      },
      {
        label: 'Undo',
        renderShortcut: getRenderShortcut('Z'),
        onClick: onUndoAction,
        disable: !undoable,
      },
      {
        label: 'Redo',
        renderShortcut: getRenderShortcut('Z', true),
        onClick: onRedoAction,
        disable: !redoable,
      },
    ],
    [undoable, redoable, enablePasteForBlock]
  );

  const isOSMac = navigator.userAgent.includes('Mac');

  return (
    <>
      {BasicContextMenuOptions.map((option) => {
        return (
          <ContextMenuButton
            onClick={option.onClick}
            className={classNames('justify-between', {
              'opacity-50 pointer-events-none': option.disable,
            })}
          >
            <>
              <div className='flex items-center gap-2'>
                <span className='text-neue-journey-medium'>{option.label}</span>
              </div>
              {option.renderShortcut(isOSMac)}
            </>
          </ContextMenuButton>
        );
      })}
    </>
  );
};
